import React, { createRef, PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
// import { callApi } from 'utils';
import { callApi } from '../../utils/callApi/rest';
import { message, Spin, Button, Tooltip } from 'antd';
import { api } from './api';
import defaultImage from './images/default_image.png';
import './index.less';
import { QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

// 应用描述区域最大高度
const descriptionMaxHeight = 66;

class AppInfoHeader extends PureComponent {
	constructor (props) {
		super(props);
		let { showProjectScope, showDepartmentScope } = props;
		let { moduleControlType } = window.$$context;
		let showComScope = showProjectScope, showOrgScope = showDepartmentScope;
		// 业务没设置是否展示管理项目范围时，如果是园区应用，默认展示；否则，不展示
		if (showComScope === undefined) {
			showComScope = moduleControlType === 'community_control';
		}
		// 业务没设置是否展示管理企业范围时，如果是企业应用，默认展示；否则，不展示
		if (showOrgScope === undefined) {
			showOrgScope = moduleControlType === 'org_control';
		}
		this.state = {
			adminList: [],				// 管理员列表
			infoLoading: false,
			adminLoading: false,
			appInfo: {},				// 应用信息
			// 是否显示‘展开/收起’按钮
			showToggleBtn: true,
			// 按钮状态
			btnStatus: 'open',
			showMoreAdmin: false,
			hasMore: false,
			showOrgScope, // 有管理企业范围
			showComScope, // 有管理项目范围
		};
		this.adminContainer = createRef();
		this.adminWrapper = createRef();
	}

	componentDidMount () {
		this.getServiceModuleApp();
		this.getHasAppManagePrivilegesUsers();
		this.state.showOrgScope && this.getDepartmentMap();
		this.state.showComScope && this.getCommunityMap();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.adminContainer.current && this.adminWrapper.current) {
			this.setState({
				hasMore: this.adminContainer.current.getBoundingClientRect().height < this.adminWrapper.current.getBoundingClientRect().height
			});
		}
	}

	// 获取所有部门的 id -- name 映射
	getDepartmentMap = () => {
		let { namespaceId, organizationId } = window.$$context;
		return callApi({
			api: api.getDepartments,
			data: { namespaceId, orgId: organizationId },
			defaultError: false,
		}).then(res => {
			const departmentsMap = new Map();
			for (let item of res) {
				departmentsMap.set(item.id, item.name);
			}
			this.setState({	departmentsMap });
		}).catch(err => {
			message.error(`获取部门数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
		});
	}

	// 获取所有项目的 projectId -- projectName 映射
	getCommunityMap = () => {
		let { namespaceId, organizationId, appId } = window.$$context;
		return callApi({
			api: api.getAuthorizedCommunities,
			data: {
				namespaceId,
				orgId: organizationId,
				// appId,
				filterByAuthorization: 0
			},
			defaultError: false,
		}).then(res => {
			const communitiesMap = new Map();
			for (let item of (res.authorizedCommunities || [])) {
				communitiesMap.set(item.projectId, item.projectName);
			}
			this.setState({ communitiesMap });
		}).catch(err => {
			message.error(`获取项目数据出错 ${err && err.errorDescription ? err.errorDescription : ''}`);
		});
	}

	/**
	 * 查询应用详情
	 */
	getServiceModuleApp = () => {
		const { appId } = window.$$context;
		this.setState({ infoLoading: true }, () => {
			callApi({
				api: api.getServiceModuleApp,
				data: { originId: appId },
				success: (res = {}) => {
					const { serviceModuleApp = {} } = res;
					this.setState({ appInfo: serviceModuleApp, infoLoading: false }, this.calcDescNodeHeight);
				},
				error: ({ errorDescription = '' }) => {
					message.error(`获取应用信息失败 ${errorDescription}`);
					this.setState({ infoLoading: false });
				}
			});
		});
	}

	// 计算应用描述区域高度
	calcDescNodeHeight = () => {
		const height = (this.descNode && this.descNode.clientHeight) || 0;
		let showToggleBtn = true, btnStatus = 'close';
		if (height <= descriptionMaxHeight) {
			showToggleBtn = false;
		}
		this.setState({showToggleBtn, btnStatus});
	}

	/**
	 * 获取系统管理员信息
	 */
	getHasAppManagePrivilegesUsers = () => {
		const { appId, organizationId, namespaceId } = window.$$context;
		this.setState({ adminLoading: true }, () => {
			callApi({
				api: api.getHasAppManagePrivilegesUsers,
				data: {
					pageSize: 99999,
					namespaceId,
					orgId: organizationId,
					appId
				},
				success: (res = {}) => {
					const { adminInfos = [] } = res;
					this.setState({ adminList: adminInfos, adminLoading: false });
				},
				error: ({ errorDescription = '' }) => {
					message.error(`获取管理员失败 ${errorDescription}`);
					this.setState({ adminLoading: false });
				}
			});
		});
	}

	goAppList = () => {
		const { history } = this.props;
		history.push('/app-config');
	}

	// 切换按钮状态
	toggle = () => {
		this.setState(oldState => ({
			btnStatus: oldState.btnStatus === 'open' ? 'close' : 'open'
		}));
	}

	onToggleMoreAdmin = () => {
		this.setState({
			showMoreAdmin: !this.state.showMoreAdmin,
		});
	}

	render () {
		const prefixCls = 'app-info-header';
		const { infoLoading, appInfo, adminList, adminLoading, showToggleBtn, btnStatus, showMoreAdmin, hasMore, showOrgScope, showComScope, departmentsMap, communitiesMap } = this.state;
		const { iconUrl = defaultImage, name = '-', description = '' } = appInfo;
		const { organizationId } = window.$$context;

		return (
			<div className={prefixCls}>
				<Spin spinning={infoLoading}>
					{/* <Button onClick={this.goAppList}>前往应用列表</Button> */}
					<div className={`${prefixCls}-info-card`}>
						<img src={iconUrl} onError={e => { e.target.src = defaultImage; }} />
						<div className='detail'>
							<div className='name'>{name}</div>
							{description && (
								<div
									className={`description ${btnStatus}`}
									ref={node => { this.descNode = node; }}
								>
									{description}
								</div>
							)}
							{
								showToggleBtn && (
									<a className='toggle-btn' onClick={this.toggle}>
										{btnStatus === 'open' ? '收起' : '展开'}
										<i className={`iconfont icon-${btnStatus === 'open' ? 'up' : 'down'}`} />
									</a>
								)
							}
						</div>
					</div>
				</Spin>
				<div className={`${prefixCls}-admin-info`}>
					<Spin spinning={adminLoading}>
						{adminList.length > 0 && <div className={`${prefixCls}-admin`}>
							<span className={`${prefixCls}-label`}>
								管理员 <Tooltip title='拥有当前应用管理权限的管理员'><QuestionCircleOutlined/></Tooltip>：</span>
							<div className={`${prefixCls}-list ${prefixCls}-admin-list ${showMoreAdmin ? 'show-more' : ''} ${hasMore ? 'has-more' : ''}`} ref={this.adminContainer}>
								<div ref={this.adminWrapper}>
									{adminList.map((item, index, arr) => {
										if (appInfo.configurable === 1 && (showComScope || showOrgScope)) {
											// 对接了权限
											return <Tooltip overlayClassName={`${prefixCls}-tooltip`} title={<>
												{showComScope && (item.communityScope
													? <div className={`${prefixCls}-tip`}>
														<span>管理项目范围：</span>
														<span>{communitiesMap && item.communityScope.map(projId => communitiesMap.get(projId)).join('，')}</span>
													</div>
													: item.allCommunityScopeFlag === 1
														? <div className={`${prefixCls}-tip`}>
															<span>管理项目范围：</span>
															<span>全部项目</span>
														</div>
														: <div className={`${prefixCls}-tip`}>
															<span>管理项目范围：</span>
															<span>无</span>
														</div>)}
												{showOrgScope && (item.orgScope
													? <div className={`${prefixCls}-tip`}>
														<span>管理企业范围：</span>
														<span>{departmentsMap && item.orgScope.map(orgId => departmentsMap.get(orgId)).join('，')}</span>
													</div>
													: item.allOrgScopeFlag === 1
														? <div className={`${prefixCls}-tip`}>
															<span>管理企业范围：</span>
															<span>全公司</span>
														</div>
														: <div className={`${prefixCls}-tip`}>
															<span>管理企业范围：</span>
															<span>无</span>
														</div>)}
											</>}>
												<span className={`${prefixCls}-list-name`} key={item.userId}>
													{item.contactName}
												</span>
											</Tooltip>;
										}
										return (
											<span className={`${prefixCls}-list-name`} key={item.userId}>
												{item.contactName}
											</span>
										);
									})}
								</div>
								{hasMore && <Button onClick={this.onToggleMoreAdmin} type='link'>展开</Button>}
							</div>
						</div>}
					</Spin>
				</div>
			</div>
		);
	}
}

AppInfoHeader.propTypes = {
	showProjectScope: PropTypes.bool,
	showDepartmentScope: PropTypes.bool,
}

export default withRouter(AppInfoHeader);
